<script>

import { useToast } from "vue-toastification";

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import UserEdit from '@/pages/Core/Users/UserEdit.vue'
import UserDelete from '@/pages/Core/Users/UserDelete.vue'
import UserGroups from '@/pages/Core/Users/UserGroups.vue'
import UserPswd from '@/pages/Core/Users/UserPswd.vue'
import UserLogins from '@/pages/Core/Users/UserLogins.vue'
import UserSysLogs from '@/pages/Core/Users/UserSysLogs.vue'


import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

import UserCircle from '@/ui/UserCircle'

//store
import {useSelectedItemStore} from "@/stores/selectedItem";
import {useSelectedFilterStore} from "@/stores/selectedFilter";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getUsers, unlockUser, unblockUser, resetAtemptsUser } from '@/services/serviceUser';
import { getGroupOptions } from '@/services/serviceGroup';


export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		let selectedFilterStore = useSelectedFilterStore();
		const allSelectedFilters = selectedFilterStore.getAllSelectedFilters;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore, allSelectedFilters, selectedFilterStore }
	},
	name: 'Users',
	mixins: [ MixinGeneralFunct ],
	components: {
		UserCircle
		,UserEdit,UserDelete,UserGroups,UserPswd,UserLogins,UserSysLogs
		,MyPagination,MyCountRecords
		,LoadingScreen
		,Alert
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			metaData:[],
			
			isLoading:true,
			
			totalCount:0,
			dataList:[],
			selectedFilterText:'',
			selectedGroups:[],
			
			optionsGroups:[],
			
			selectedUserId:'',
						
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			checkAllItems:false,
			
			
		
			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false,


			modalDelete:{},
			modalDeleteId:'',
			
			modalEdit:{},
			modalEditId:'',
			
			modalGroup:{},
			modalGroupId:'',
			
			modalPswd:{},
			modalPswdId:'',
			
			modalLogin:{},
			modalLoginId:'',
			
			modalLogs:{},
			modalLogsId:'',

			
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modaluser${this.getRandomInt(999999999)}`;
		this.modalEditId = `modaluser${this.getRandomInt(999999999)}`;
		this.modalGroupId = `modaluser${this.getRandomInt(999999999)}`;
		this.modalPswdId = `modaluser${this.getRandomInt(999999999)}`;
		this.modalLoginId = `modaluser${this.getRandomInt(999999999)}`;
		this.modalLogsId = `modaluser${this.getRandomInt(999999999)}`;

	},
	
	methods: {
		
		
		//default data
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true

			getUsers({filterText: this.selectedFilterText, filterGroups: JSON.stringify(this.allSelectedFilters), orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}

				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
			
			
			getGroupOptions().then(response => {
				this.optionsGroups=response.optionsGroups;
				//oznacenie poloziek filter
				for(let i = 0; i < this.optionsGroups.length; i++){
					if(this.allSelectedFilters.indexOf(this.optionsGroups[i].id)>=0){
						this.optionsGroups[i].isSelected=true;
					}
				}
			});

		},

		//odomknutie zaznamu
		onUnLock:function(userId){
			this.cSession();
			this.isLoading=true
			unlockUser({userId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},

		//zrusenie aktivnych prihlaseni
		onUnBlock:function(userId){
			this.cSession();

			unblockUser({userId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnblocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnBlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnblocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});			
		
		},
		
		//zrusenie pokusov o prihlasenie
		onResetAttempts:function(userId){
			this.cSession();
			
			resetAtemptsUser({userId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnblocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnBlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnblocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});			
		
		},
		
		
		//(od)oznacenie vsetkych poloziek
		onCheckAllItems:function(){
			if(this.checkAllItems){
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.dataList[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},
		
		//oznacenie jednej polozky
		onCheckItem:function(index,id){
			if(this.dataList[index].selectedId==true){
				this.selectedItemStore.addSelectedItems(id);
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected:function(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.dataList.findIndex(item => item.id==this.allSelectedItems[i]); 
					if(index>=0){
						this.dataList[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},

		//oznacenie jedneho filtra
		onCheckFilter:function(index,id){
			if(this.optionsGroups[index].isSelected==true){
				this.selectedFilterStore.addFilters(id);
			}else{
				var indexToRemove = this.allSelectedFilters.indexOf(id);
				this.selectedFilterStore.deleteFilters(indexToRemove);
			}
			this.onLoadPage();
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box user editacia
		loadModalFormUserEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box user delete
		loadModalFormUserDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},
		
		//modal box user select access groups
		loadModalFormUserGroupEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalGroup = new bootstrap.Modal(document.getElementById(this.modalGroupId), {backdrop:'static'})
			this.modalGroup.show();
		},
		
		//modal box user change pswd
		loadModalFormUserSetPswd:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalPswd = new bootstrap.Modal(document.getElementById(this.modalPswdId), {backdrop:'static'})
			this.modalPswd.show();
		},
		
		//modal box user logins list
		loadModalLoginsList:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalLogin = new bootstrap.Modal(document.getElementById(this.modalLoginId), {backdrop:'static'})
			this.modalLogin.show();
		},
		
		//modal box user sys logs
		loadModalSysLogsList:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedUserId=recordID;
			this.modalLogs = new bootstrap.Modal(document.getElementById(this.modalLogsId), {backdrop:'static'})
			this.modalLogs.show();
		},
		
		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedUserId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},
		
	},	
	
			
	watch: {
		'auth.usersList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				
		<div v-if="metaData.modulAccess"> 
		
			<div class="row">
				<div class="col-12">
									
						<div class="row">
							<div class="col-6">
								<h5>{{ $t('msgCore.menu-users') }}</h5>	 
							</div> 
							
							<div class="col-6 right">
								
								<button type="button" :disabled="!auth.usersNew" v-on:click="loadModalFormUserEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
								
								<button type="button" :disabled="!auth.usersUpload" v-on:click="loadModalFormUserUpload()" :title="$t('msgCore.btnUpload')" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-upload"></i> {{ $t('msgCore.btnUpload') }}</button>
								
							</div> 
						</div>

						<!-- filters basic -->
						<div class="row">
						
							<div class="input-group col-md-4 col-12">
								<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
									<span v-if="filterExtended">
										<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
										<i v-else class="smire-icon fas fa-search-minus"></i>
									</span>
									<span v-else>
										<i class="smire-icon fas fa-search"></i> 
									</span>
									{{ $t('msgCore.btnFilter') }}
								</button>
								<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
								<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
									<i class="smire-icon fas fa-times"></i>
								</button>
							</div>
							
						</div>

						<!-- filters extended -->
						<div v-show="showFilter && filterExtended" class="row">
							
							<div class="form-group-filter col-12">
								
								<div v-for="(option,index) in optionsGroups" :key="option" class="form-check form-check-inline">
									<label class="form-check-label">	
										<input v-model.number='option.isSelected' class="form-check-input" type="checkbox" v-on:change="onCheckFilter(index,option.id)">{{ option.title }}
										<span class="form-check-sign">
											<span class="check"></span>
										</span>
									</label>
								</div>
							
							</div>

						</div>
						
				</div>
			</div>	

			
			<!-- zakladny zoznam -->
			<div v-if="totalCount>0">
			
					<div class="row">
						<div class="col-12">
		
							<div class="table-responsive">
								<table class="table table-hover table-sm">
								
									<thead>
										<tr>
											<th class="orderBy" v-on:click="orderByCol('a.id')" :class="{ active: isActive('a.id'), asc: isAsc('a.id'), desc: isDesc('a.id')}">id</th>
										
											<th width="10" class="align-middle">
												<div class="form-check">
													<label class="form-check-label">
													<input v-model="checkAllItems" v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox">
													<span class="form-check-sign">
														<span class="check"></span>
													</span>
													</label>
												</div>
											</th>
										
											<th>
												{{$t('msgCore.Action')}}
											</th>
											
											<th>{{$t('msgCore.State')}}</th>
											
											<th>{{$t('msgCore.Type')}}</th>
											
											<th>{{$t('msgCore.TitleBeforeShort')}}</th>
											
											<th>{{$t('msgCore.Name')}}</th>
											<th>{{$t('msgCore.Surname')}}</th>
											
											<th>{{$t('msgCore.TitleAfterShort')}}</th>
											
											<th>{{$t('msgCore.MultiLogin')}}</th>
											
											<th>{{$t('msgCore.Validity')}}</th>
											
											<th>{{$t('msgCore.Email')}}</th>
											
											<th>{{$t('msgCore.Groups')}}</th>
											
											<th>{{$t('msgCore.Levels')}}</th>
											
											<th>{{$t('msgCore.Created')}}</th>
											
											<th>{{$t('msgCore.Modified')}}</th>
											
											<th>{{$t('msgCore.AccessLevel')}}</th>
																			
										</tr>
									</thead>
									
									
									<tr v-for="(basicObj, index) in dataList" :key="basicObj">
									
										<td>{{ basicObj.id }}</td>
										
										<td class="align-middle">
											<div class="form-check">
												<label class="form-check-label">
												<input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox" v-on:change="onCheckItem(index,basicObj.id);">
												<span class="form-check-sign"><span class="check"></span></span>
												</label>
											</div>	
										</td>
									
										<td>
											<button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.usersUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
										
											<div class="input-group">	
																		
												<div class="btn-group">				
													<button type="button" :disabled="!auth.usersEdit" v-on:click="loadModalFormUserEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>
													
													<button type="button" :disabled="!auth.usersDelete" v-on:click="loadModalFormUserDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>
																											
												</div>	
												
												<div class="btn-group">	
												
													<button type="button" :disabled="!auth.usersChangeGroups" v-on:click="loadModalFormUserGroupEdit(basicObj.id)" :title="$t('msgCore.accessGroups')" class="btn btn-warning btn-sm"><i class="smire-icon fas fa-cog"></i></button>
											
													<button type="button" :disabled="!auth.usersChangePasswd" v-on:click="loadModalFormUserSetPswd(basicObj.id)" :title="$t('msgCore.changePassword')" class="btn btn-warning btn-sm"><i class="smire-icon fas fa-shield-alt"></i></button>
													
													<button type="button" :disabled="!auth.usersShowLoginData" v-on:click="loadModalLoginsList(basicObj.id)" :title="$t('msgCore.loginData')" class="btn btn-success btn-sm"><i class="smire-icon fas fa-clipboard-list"></i></button>
													
													<button type="button" :disabled="!auth.usersShowSysLogData" v-on:click="loadModalSysLogsList(basicObj.id)" :title="$t('msgCore.sysLogData')" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-info"></i></button>
													
													<button v-if="basicObj.logins.length>0" type="button" :disabled="!auth.usersUnblock" v-on:click="onUnBlock(basicObj.id)" :title="$t('msgCore.btnUnblock')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-unlock"></i></button>
													
													<button v-if="basicObj.attempts.length>0" type="button" :disabled="!auth.usersUnblock" v-on:click="onResetAttempts(basicObj.id)" :title="$t('msgCore.btnResetAttempts')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-undo-alt"></i></button>
													
													
													
												</div>	
											</div>	
										</td>
										
										<td :title="basicObj.state_name">
											<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
										</td>

										<td :title="$t('msgCore.'+basicObj.type_name)">
											<i class="fas fa-circle" v-bind:style="{color:basicObj.color}" ></i>
											<i v-if="basicObj.type==1" :class="{'text-success':basicObj.type==1}" class="fas fa-sitemap"></i>
											<i v-if="basicObj.type==2" :class="{'text-danger':basicObj.type==2}" class="fas fa-external-link-square-alt"></i>
										</td>														
											
										<td >{{ basicObj.titleBefore }}</td>
										<td ><i v-if="basicObj.titleInName" class="fas fa-exclamation-triangle red"></i>{{ basicObj.name }}</td>
										<td ><i v-if="basicObj.titleInSurname" class="fas fa-exclamation-triangle red"></i>{{ basicObj.surname }}</td>
										<td >{{ basicObj.titleAfter }}</td>
										
										<td ><span v-if="basicObj.multi==0"><i class="fas fa-infinity"></i></span><span v-else>{{ basicObj.multi }} ({{basicObj.logins.length}})</span>
										<span v-if="!basicObj.isSetPassword" :title="$t('msgCore.PasswordIsNotSet')"><i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i></span>
										
										</td>	

										<td>
											<i v-if="!basicObj.isValid" class="fas fa-exclamation-triangle red" aria-hidden="true"></i>
											<i v-if="basicObj.isWarning && basicObj.isValid" class="fas fa-exclamation-triangle text-warning" ></i>
											<i v-if="!basicObj.isWarning && basicObj.isValid" class="fas fa-check text-success" ></i>
											<span v-if="basicObj.isWarning || !basicObj.isValid">{{ basicObj.warningTime }}</span>
										</td>
										
										
										<td >{{ basicObj.email }}</td>														
										
										<td >
											<span v-for="(group) in basicObj.accessGroups" :key="group">
												<span >{{ group.title }}</span><br>
											</span>
										</td>
										
										<td >
											<span v-for="(level) in basicObj.accessLevels" :key="level">
												<span >{{ level.title }}</span><br>
											</span>
										</td>
										
										<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
                                        
										
									
										<td >{{ basicObj.access_name }}</td>
										
										
									</tr>
										

								
								</table>	
							</div>		
						
						</div>
					</div>
						
					<div class="row row-pagination">
						<div class="col-6 col-md-3 col-lg-2">
							<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
						</div>
						
						<div class="col-6 col-md-3 col-lg-2 box-flex">
							<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="onResetSelected()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
						</div>
						
						<div class="col-12 col-md-6 col-lg-8">	
							<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
						</div>
					</div>
					
				
			</div>	
			
			<div v-else class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>							
			</div>
			
		</div>	
		
		<div v-else >
			<div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
			</div>
		</div>
	
		<UserEdit :auth="auth" :secData="secData" :params="params" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></UserEdit>
		
		<UserDelete :auth="auth" :secData="secData" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></UserDelete>
		
		<UserGroups :auth="auth" :secData="secData" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalGroup" :modalId="modalGroupId"></UserGroups>
		
		<UserPswd :auth="auth" :secData="secData" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalPswd" :modalId="modalPswdId"></UserPswd>
		
		<UserLogins :auth="auth" :secData="secData" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalLogin" :modalId="modalLoginId"></UserLogins>
		
		<UserSysLogs :auth="auth" :secData="secData" :userId="String(selectedUserId)" @changeRecord="onChangeItem" :modalObject="modalLogs" :modalId="modalLogsId"></UserSysLogs>
	</div>	
</template>


